import { styled } from '@creditas/stylitas'

const MessageWrapper = styled.div`
  display: grid;
  grid-template-columns: [content] auto [action] 48px;

  strong {
    font-weight: bold;
  }

  div {
    align-self: center;
  }
`

export { MessageWrapper }
